const IGNORED_WORDS = [
  'a',
  'as',
  'o',
  'os',
  'de',
  'da',
  'das',
  'do',
  'dos',
  'e',
  'em',
  'ltda',
  'me',
  'epp',
  'eireli',
  'sa',
  's/a',
  'mei',
];

export const companyInitials = (name: string): string => {
  const words = name
    .replace(/^[\d./-]+\s+/, '')
    .split(/\s+/)
    .map((word) => word.replace(/[^0-9A-Za-zÀ-ÿ/]/g, ''))
    .filter((word) => word && !IGNORED_WORDS.includes(word.toLowerCase()));

  if (words.length === 0) return name.trim().slice(0, 2).toUpperCase();
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();

  return `${words[0][0]}${words[1][0]}`.toUpperCase();
};

export const compactCompanies = <T>(companies: T[]): Array<T | number> =>
  companies.length <= 2 ? companies : [companies[0], companies.length - 1];

export const monitoredByText = (names: string[]): string => {
  if (names.length <= 1) return `Monitorado por: ${names.join('')}`;

  return `Monitorado por: ${names.slice(0, -1).join(', ')} e ${names[names.length - 1]}`;
};
